import { hideModal, showModal } from "app/modules/modal-management/reducer/action";
import { getErrorMessage } from "app/shared/services/axios";
import { RESPONSEBASE } from "app/shared/services/services-model.type";
import { AxiosError, AxiosResponse } from "axios";
import { all, call, put, takeLatest } from "redux-saga/effects";
import { fetchTermDepositListService } from "../services/term-deposit-list.service";
import { fetchTermDepositListFailure, fetchTermDepositListSuccess } from "./actions";
import { FETCH_TERM_DEPOSIT_LIST_REQUEST } from "./actions.type";

function* fetchTermDepositListSaga() {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(fetchTermDepositListService);
    console.log("fetchTermDepositList response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      yield put(fetchTermDepositListSuccess(response.data.RESPONSEDATA?.LIST_ACCOUNT_PROFILE));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchTermDepositListFailure(msg));
  }
}

function* termDepositListSaga() {
  yield all([takeLatest(FETCH_TERM_DEPOSIT_LIST_REQUEST, fetchTermDepositListSaga)]);
}

export default termDepositListSaga;
